module.exports = "<app-header></app-header>\n<app-navbar></app-navbar>\n\n<section class=\"wait\">\n  敬请期待 !\n</section>\n"


//////////////////
// WEBPACK FOOTER
// /Users/apple/Documents/object/chinaicac-portal/src/app/knowledgecenter/ranking/ranking.component.html
// module id = ../../../../../src/app/knowledgecenter/ranking/ranking.component.html
// module chunks = main